import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import { File } from '../_model/File';
import { GeneralDocumentAddRequest } from '../_model/request/GeneralDocumentAddRequest';
import { GeneralDocumentCreateRequest } from '../_model/request/GeneralDocumentCreateRequest';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends BaseService {

constructor(private httpClient: HttpClient) {
  super(httpClient);
 }

getFile(): Observable<ApiResponse>{
  return this.get<ApiResponse>('/api/v1/general_document');
}
getAllFolders(): Observable<ApiResponse> {
  return this.post<ApiResponse>('/api/v1/general_document/all-folders', {});
}
addFile(documentAddRequest: GeneralDocumentAddRequest):Observable<ApiResponse> 
{
  return this.post<ApiResponse>('/api/v1/general_document',documentAddRequest);
}
getFileFromId(id: any): Observable<ApiResponse>  {
  throw new Error("Method not implemented.");
}
createDocument(request: GeneralDocumentCreateRequest): Observable<any> {
    return this.post<any>('/api/v1/general_document', request);
}
deleteDocument(id: number): Observable<any> {
    return this.delete<any>(`/api/v1/general_document/${id}`);
}
}
